import logo from "@/assets/logo.png";
import {BaseButton} from "@/components/BaseButton";
import {BaseInput} from "@/components/BaseInput";
import {useLogin} from "./useLogin";

export const Login = () => {
  const {form, errors, serverError, loading, setField, submit} = useLogin();

  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    submit();
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-8">
      {/* Logo + brand */}
      <div className="flex flex-col items-center mb-8">
        <img
          src={logo}
          alt="Remesas 365"
          className="w-14 h-14 object-contain mb-4"
        />
        <h1
          className="text-2xl font-bold"
          style={{color: "var(--color-primary)"}}
        >
          Backoffice
        </h1>
        <p
          className="text-sm mt-1"
          style={{color: "var(--color-text-secondary)"}}
        >
          Remesas 365 — Admin Panel
        </p>
      </div>

      {/* Form */}
      <form
        onSubmit={handleSubmit}
        className="flex flex-col gap-5"
        noValidate
      >
        <BaseInput
          label="Username"
          type="text"
          placeholder="admin"
          value={form.username}
          onChange={e => setField("username", e.target.value)}
          error={errors.username}
          autoComplete="username"
          autoFocus
        />

        <BaseInput
          label="Password"
          type="password"
          placeholder="••••••••"
          value={form.password}
          onChange={e => setField("password", e.target.value)}
          error={errors.password}
          autoComplete="current-password"
        />

        {/* Server error */}
        {serverError && (
          <div
            className="px-4 py-3 text-sm rounded-md"
            style={{
              backgroundColor: "var(--color-danger-bg)",
              color: "var(--color-danger-text)",
              border: "1px solid var(--color-danger)",
            }}
          >
            {serverError}
          </div>
        )}

        <BaseButton
          type="submit"
          variant="primary"
          size="lg"
          loading={loading}
          className="w-full mt-1"
        >
          Sign in
        </BaseButton>
      </form>
    </div>
  );
};
